import { romeApi } from "framework";
import { min } from "moment";
import store from "../../store";
import sendPlanDoc from './SendPlanDocEnrollments'

class SendPlanDocService {
    constructor(){
        this.$store = store;
    }

    async onComplete(actionItem){
        
        var res = await modalService.show('sendPlanDoc', sendPlanDoc, null);
        
        if(res != null){          
            res.workflowId = actionItem.workflowId;
            
            await romeApi.post(`employer/${actionItem.employerId}/plandoc/confirmation`, res);         
           
            await this.$store.dispatch("actionItems/changeStatus", { actionItem, newStatus: "completed", onComplete: null, overrideValidation: true });      
        }    
    }

    async completeAmended(actionItem) {
        var res = await modalService.show('sendPlanDoc', sendPlanDoc, null);
        
        if(res != null){            
            await romeApi.post(`employer/${actionItem.employerId}/plandocument/confirmation`, res);         
           
            await this.$store.dispatch("actionItems/changeStatus", { actionItem, newStatus: "completed", onComplete: null, overrideValidation: true });      
        }    
    }
}

const sendPlanDocService = new SendPlanDocService();

export { sendPlanDocService };



// WEBPACK FOOTER //
// ./src/action-items/types/send-plan-doc-service.js